import type {
  EssayProblemType,
  ProblemLevel,
  ProblemType,
  SimilarLevel,
  TagTopType,
} from './schemas'

/***************** 난이도 *****************/
// CMS·서버의 Level enum 과 같은 라벨이다.
export const PROBLEM_LEVEL_KO = {
  1: '하',
  2: '중하',
  3: '중',
  4: '상',
  5: '최상',
} as const satisfies Record<ProblemLevel, string>
export type ProblemLevelKo = (typeof PROBLEM_LEVEL_KO)[ProblemLevel]

/***************** 정답 형식 *****************/
export const PROBLEM_TYPE_KO = {
  SINGLE_CHOICE: '객관식',
  MULTIPLE_CHOICE: '선다형',
  SHORT_ANSWER: '주관식',
  ESSAY: '서술형',
} as const satisfies Record<ProblemType, string>

/***************** 문제 태그 *****************/
export const TAG_TOP_PREFIX = {
  twin: '[쌍둥이]',
  similar: '[유사]',
  wrong: '[틀린 문제]',
  same: '[동일]',
} as const satisfies Record<TagTopType, string>

/***************** 유사문제 난이도 *****************/
export const SIMILAR_LEVEL_KO = {
  EASIER: '더 쉽게',
  AS_IS: '그대로',
  HARDER: '더 어렵게',
} as const satisfies Record<SimilarLevel, string>

/***************** 서술형 답안 형식 *****************/
export const ESSAY_PROBLEM_TYPE_LABEL = {
  BLANK: '빈칸형',
  STEP: '단계형',
  DESCRIPTIVE: '서술형',
  HANDWRITING: '필기형',
} as const satisfies Record<EssayProblemType, string>
